module.exports = __webpack_public_path__ + "media/images/lb/061-6614907dd128d27434e6ac4d1c516c33.svg";